import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, linkTo, title, claimIds } = appSections.edo;
export const edoRoute = {
    path: rootPath,
    lazy: async () => {
        const { Edo } = await import('@/admin/modules/edo');
        return {
            element: (_jsx(ProtectedRoute, { claims: claimIds, children: _jsx(Edo, {}) })),
        };
    },
    handle: {
        crumb: () => _jsx(NavLink, { to: linkTo, children: title }),
    },
};
